import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { getHeaderHeights } from './header.utils';
import { MEDIA_BREAKPOINTS } from '../../../../mediaQueries.const';
import { ErrorBoundary } from '../../../errorHandling/ErrorBoundary';
import { AnimationDirectionType } from './menuAnimations.util';

interface MontiAnchorProps {
  isSecondaryHeaderEnabled: boolean;
  menuAnimation: AnimationDirectionType;
}

const getStyle = (isSecondaryHeaderEnabled: boolean) => {
  const heights = getHeaderHeights(isSecondaryHeaderEnabled);
  return StyleSheet.create({
    anchor: {
      position: 'fixed',
      [MEDIA_BREAKPOINTS.large]: {
        top: heights.large,
      },
      [MEDIA_BREAKPOINTS.medium]: {
        top: heights.medium,
      },
      [MEDIA_BREAKPOINTS.small]: {
        top: heights.small,
      },
      left: 0,
      right: 0,
      height: 0,
      transition: '800ms',
    },
    foldingUp: {
      [MEDIA_BREAKPOINTS.medium]: {
        top: 0,
      },
      [MEDIA_BREAKPOINTS.small]: {
        top: 0,
      },
    },
    foldingDown: {
      [MEDIA_BREAKPOINTS.medium]: {
        top: heights.medium,
      },
      [MEDIA_BREAKPOINTS.small]: {
        top: heights.small,
      },
    },
  });
};

export const MontiAnchor: React.FC<MontiAnchorProps> = props => {
  const { isSecondaryHeaderEnabled, menuAnimation } = props;
  const style = getStyle(isSecondaryHeaderEnabled);
  let finalStyle;
  switch (menuAnimation) {
    case 'foldingUp': finalStyle = css(style.anchor, style.foldingUp); break;
    case 'foldingDown': finalStyle = css(style.anchor, style.foldingDown); break;
    default: finalStyle = css(style.anchor);
  }

  return <ErrorBoundary><div className={`${finalStyle} video-top-anchor`} /></ErrorBoundary>;
};
